import { useEffect, useRef, useState } from 'react';

type TextCanvasProps = {
  text: string;
  textColor: string;
  inline?: boolean;
};

export const TextCanvas = ({
  text,
  textColor,
  inline,
}: TextCanvasProps): JSX.Element => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [width, setWidth] = useState<any>();

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    setWidth(ctx?.measureText(text).width);

    if (ctx) {
      ctx.font = '500 13px Spartan';
      const textMetrics = ctx.measureText(text);
      setWidth(textMetrics.width);

      canvas.width = textMetrics.width;
      canvas.height = 17;

      ctx.font = '500 13px Spartan';
      ctx.fillStyle = textColor;
      ctx.fillText(text, 0, 15);
    }
  }, [text, textColor, width]);

  return (
    <canvas
      ref={canvasRef}
      width={width}
      height={17}
      style={{
        display: inline ? 'inline-block' : '',
        minWidth: `${width}px`,
      }}
    />
  );
};
